import { SelectOption } from '@fleet-beat/core';

export enum SafetyEventSeverityEnum {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export const SafetyEventSeverityOptions: SelectOption[] = [
  { value: SafetyEventSeverityEnum.LOW, label: 'Low' },
  { value: SafetyEventSeverityEnum.MEDIUM, label: 'Medium' },
  { value: SafetyEventSeverityEnum.HIGH, label: 'High' },
  { value: SafetyEventSeverityEnum.CRITICAL, label: 'Critical' },
];
